<template>
    <modal ref="modal" unclosable>
        <div id="sub-wrapper">
            <div class="text">{{ $t('modals.linkedin_select.text') }}</div>
            <toggles v-model='targets' :list='list()'/>
            <button @click="choose">{{ $t('modals.linkedin_select.buttons.choose') }}</button>
            <button class="button-2" @click="cancel">{{ $t('modals.linkedin_select.buttons.cancel') }}</button>
        </div>
    </modal>
</template>

<script>
import distributor from '@/services/distributor'

export default {
  data () {
    return {
      distributorId: null,
      onDone: null,
      organizations: [],
      targets: []
    }
  },
  methods: {
    show (distributorId, organizations, onDone) {
      this.distributorId = distributorId
      this.onDone = onDone
      this.organizations = organizations
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    list () {
      var l = []
      this.organizations.forEach(organization => {
        l.push({
          disabled: false,
          id: 'organization.' + organization.id,
          initial: false,
          name: this.$t('modals.linkedin_select.organization', { name: organization.name }),
          value: JSON.stringify({ kind: 'organization', id: organization.id })
        })
      })
      return l
    },
    cancel () {
      // On done
      if (this.onDone) this.onDone()
    },
    choose () {
      // Show loader
      this.$parent.$parent.$refs.loader.show()

      // Create targets
      var targets = []
      this.targets.forEach(target => targets.push(JSON.parse(target)))

      // Update distributor
      distributor.update(this.distributorId, targets)
        .then(() => {
          // Hide loader
          this.$parent.$parent.$refs.loader.hide()

          // Hide modal
          this.hide()

          // On done
          if (this.onDone) this.onDone()
        })
        .catch(() => {
          // Hide loader
          this.$parent.$parent.$refs.loader.hide()

          // Show error
          this.$parent.$parent.$refs.toaster.error(this.$i18n.t('errors.default'))
        })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 25em;
}

#sub-wrapper .text, #sub-wrapper #toggles {
  margin-bottom: 1.5em;
}

#sub-wrapper button:last-child {
  margin-left: 0.5em;
}

#sub-wrapper .button-2 {
    background-color: #7c7c7c;
    color: #ffffff;
}

#sub-wrapper .button-2:hover {
    background-color: #8c8c8c;
    color: #ffffff;
}

</style>
